import globalIP from '@/GlobelIP';
import React, { useEffect, useState } from 'react'
import { Table, Toggle } from 'rsuite';
const { HeaderCell, Cell } = Table;
const UserAuth = ({data1}) => {
    const [data, setData] = useState([]);
  useEffect(() => {
    fetchDatauser();
  }, []);
  const fetchDatauser = async () => {
    const response = await fetch(
      `${globalIP}/api/user-details?populate=*&pagination[page]=1&sort[0]=id:desc`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/user-details?populate=*&pagination[page]=${page}&sort[0]=id`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setData(allData);
  };
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 250; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);

  const handleToggleChangeuser = async (id, currentValue) => {
    const updatedValue = !currentValue;

    // Optimistically update the UI
    setData(prevData =>
      prevData.map(user =>
        user.id === id
          ? { ...user, attributes: { ...user.attributes, Authorised: updatedValue } }
          : user
      )
    );
    try {
      const response = await fetch(`${globalIP}/api/user-details/${id}`, {
        method: 'PUT', // or PATCH if partial update
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: { Authorised: updatedValue }
        })
      });
      if (!response.ok) {
        console.error('Failed to update Authorised status.');
        // Revert the optimistic update if API fails
        setData(prevData =>
          prevData.map(user =>
            user.id === id
              ? { ...user, attributes: { ...user.attributes, Authorised: currentValue } }
              : user
          )
        );
      }
    } catch (error) {
      console.error('Error updating Authorised status:', error);
      // Revert the optimistic update if API fails
      setData(prevData =>
        prevData.map(user =>
          user.id === id
            ? { ...user, attributes: { ...user.attributes, Authorised: currentValue } }
            : user
        )
      );
    }
  };

  const handleToggleChangeuser1 = async (id, currentValue) => {
    const updatedValue = !currentValue;

    // Optimistically update the UI
    setData(prevData =>
      prevData.map(user =>
        user.id === id
          ? { ...user, attributes: { ...user.attributes ,PriceList: updatedValue } }
          : user
      )
    );
    try {
      const response = await fetch(`${globalIP}/api/user-details/${id}`, {
        method: 'PUT', // or PATCH if partial update
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: { PriceList: updatedValue }
        })
      });
      if (!response.ok) {
        console.error('Failed to update PriceList status.');
        // Revert the optimistic update if API fails
        setData(prevData =>
          prevData.map(user =>
            user.id === id
              ? { ...user, attributes: { ...user.attributes, PriceList: currentValue } }
              : user
          )
        );
      }
    } catch (error) {
      console.error('Error updating PriceList status:', error);
      // Revert the optimistic update if API fails
      setData(prevData =>
        prevData.map(user =>
          user.id === id
            ? { ...user, attributes: { ...user.attributes, PriceList: currentValue } }
            : user
        )
      );
    }
  };

  
  return (
    <Table
                  rowHeight={60}
                  cellBordered
                  data={data}
                  height={tableHeight}
                  rowKey="id"
                  bordered
                >
                  <Table.Column width={60} align="center" fixed>
                    <HeaderCell>
                      <b style={{ fontSize: '14px' }}>Sr.No.</b>
                    </HeaderCell>
                    <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
                  </Table.Column>

                  <Table.Column width={150} align="center">
                    <Table.HeaderCell>
                      <b style={{ fontSize: '14px' }}>Company Name</b>
                    </Table.HeaderCell>
                    <Table.Cell>
                      {rowData =>
                        data1.find(category => category.value === rowData.attributes.Company_Name)
                          ?.label || ''
                      }
                    </Table.Cell>
                  </Table.Column>

                  <Table.Column width={100} align="center">
                    <Table.HeaderCell>
                      <b style={{ fontSize: '14px' }}>Image</b>
                    </Table.HeaderCell>
                    <Table.Cell>
                      {rowData => {
                        const userImage =
                          rowData.attributes?.UserImage?.data?.attributes?.url || '';
                        return (
                          <>
                            {userImage ? (
                              <img
                                src={`${globalIP}${userImage}`}
                                alt="User Image"
                                style={{ width: 50, height: 50, marginTop: '-16px' }}
                              />
                            ) : (
                              'No image'
                            )}
                          </>
                        );
                      }}
                    </Table.Cell>
                  </Table.Column>
                  <Table.Column width={150} align="center" flexGrow={1} fullText>
                    <Table.HeaderCell>
                      <b style={{ fontSize: '14px' }}>Full Name</b>
                    </Table.HeaderCell>
                    <Cell dataKey="attributes.Full_Name" />
                  </Table.Column>
                  <Table.Column width={100} align="center">
                    <Table.HeaderCell>
                      <b style={{ fontSize: '14px' }}>Category</b>
                    </Table.HeaderCell>
                    <Cell dataKey="attributes.Category" />
                  </Table.Column>
                  <Table.Column width={150} align="center" fullText>
                    <Table.HeaderCell>
                      <b style={{ fontSize: '14px' }}>Access</b>
                    </Table.HeaderCell>
                    <Cell>
                      {rowData => (
                        <Toggle
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                          checked={rowData?.attributes?.Authorised}
                          onChange={() =>
                            handleToggleChangeuser(rowData.id, rowData?.attributes?.Authorised)
                          }
                        />
                      )}
                    </Cell>
                  </Table.Column>
                  <Table.Column width={150} align="center" fullText>
                    <Table.HeaderCell>
                      <b style={{ fontSize: '14px' }}>PriceList</b>
                    </Table.HeaderCell>
                    <Cell>
                      {rowData => (
                        <Toggle
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                          checked={rowData?.attributes?.PriceList}
                          onChange={() =>
                            handleToggleChangeuser1(rowData.id, rowData?.attributes?.PriceList)
                          }
                        />
                      )}
                    </Cell>
                  </Table.Column>
                </Table>
  )
}

export default UserAuth
